// src/Lounge.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Lounge_default = createIcon({
  displayName: "Lounge",
  viewBox: "0 0 24 25",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "25", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.00005 13.25V14H15.0001V13.25C15.0001 10.3554 17.3548 7.99999 20.25 7.99999C20.4324 7.99999 20.6153 8.01693 20.7981 8.0357C20.14 5.43676 17.8006 3.5 15.0001 3.5H9.00005C6.19953 3.5 3.86008 5.43681 3.20203 8.0357C3.38478 8.01693 3.56768 7.99999 3.75007 7.99999C6.6453 7.99999 9.00005 10.3554 9.00005 13.25Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.849 12.1757C23.5046 10.9487 22.4921 9.95332 21.2589 9.63162C18.7531 8.97782 16.4999 10.8507 16.4999 13.2501V15.5H7.50001V13.25C7.50001 10.8507 5.2469 8.97782 2.74108 9.63157C1.50788 9.95327 0.495386 10.9486 0.150976 12.1756C-0.207809 13.4538 0.0990606 14.6553 0.794519 15.5409C1.22893 16.0943 1.5 16.7557 1.5 17.4592V20H4.49998V21.5H7.49996V20H16.4999V21.5H19.4999V20H22.4999V17.4592C22.4999 16.7558 22.771 16.0943 23.2054 15.5409C23.9009 14.6553 24.2078 13.4538 23.849 12.1757ZM3.74995 14C3.33577 14 2.99997 13.6642 2.99997 13.2501C2.99997 12.8358 3.33577 12.5001 3.74995 12.5001C4.16413 12.5001 4.49994 12.8358 4.49994 13.2501C4.49994 13.6642 4.16413 14 3.74995 14ZM20.25 14C19.8358 14 19.5 13.6642 19.5 13.2501C19.5 12.8358 19.8358 12.5001 20.25 12.5001C20.6641 12.5001 20.9999 12.8358 20.9999 13.2501C20.9999 13.6642 20.6641 14 20.25 14Z",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Lounge_default
};
